import {
  DENSITY_COLOR,
  FILM_TYPE,
  MAGNIFICATION,
  MEDIUM_TYPE,
  ORIENTATION,
  PrintExtraSettings,
  PrintSettings,
  TRIM,
} from '@vindr/services/constants/print.constant';
import { Checkbox, Col, Form, Input, Modal, Row, Select } from 'antd';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const PrintSettingsExtendForm = ({
  settings,
  open,
  onOk,
  onCancel,
}: {
  settings: PrintSettings;
  open: boolean;
  onOk: (output: PrintExtraSettings) => unknown;
  onCancel: () => unknown;
}) => {
  const { t } = useTranslation('ViewerTool');
  const [form] = Form.useForm<PrintExtraSettings>();

  useEffect(() => {
    form.setFieldsValue(settings);
  }, [form, settings]);

  return (
    <Modal
      open={open}
      maskClosable={false}
      centered
      onOk={() => onOk(form.getFieldsValue())}
      destroyOnClose
      forceRender
      onCancel={onCancel}
      okText={t('OK')}
      title={t('Settings')}
      // confirmLoading={isCreating || isUpdating}
      width="1200"
    >
      <Form
        form={form}
        onFinish={onOk}
        name="edit-procedure"
        labelCol={{ span: 12 }}
        labelAlign="left"
      >
        <Row gutter={16}>
          <Col xs={24} md={12}>
            <Form.Item
              name="medium_type"
              label={
                <Checkbox className="-mr-2" defaultChecked={true}>
                  {t('Medium Type')}
                </Checkbox>
              }
              className="mb-2"
              initialValue={'CLEAR FILM'}
            >
              <Select placeholder={t('Select')} size="small">
                {MEDIUM_TYPE.map((it) => (
                  <Select.Option key={it.key} value={it.key} title={it.title}>
                    {it.title}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item
              name="magnification"
              label={
                <Checkbox className="-mr-2" defaultChecked={true}>
                  {t('Magnification')}
                </Checkbox>
              }
              className="mb-2"
              initialValue={'BILINEAR'}
            >
              <Select placeholder={t('Select')} size="small">
                {MAGNIFICATION.map((it) => (
                  <Select.Option key={it.key} value={it.key} title={it.title}>
                    {t(it.title)}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col xs={24} md={12}>
            {/* <Form.Item
              name=""
              label={
                <Checkbox className="-mr-2" defaultChecked={true}>
                  {t('Destination')}
                </Checkbox>
              }
              className="mb-2"
              initialValue={'PROCESSOR'}
            >
              <Select placeholder={t('Select')} size="small">
                {DESTINATION.map((it) => (
                  <Select.Option key={it.key} value={it.key} title={it.title}>
                    {it.title}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item
              name="priority"
              label={
                <Checkbox className="-mr-2" defaultChecked={true}>
                  {t('Priority')}
                </Checkbox>
              }
              className="mb-2"
              initialValue={'MED'}
            >
              <Select placeholder={t('Select')} size="small">
                {PRIORITY.map((it) => (
                  <Select.Option key={it.key} value={it.key} title={it.title}>
                    {it.title}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item> */}
            <Form.Item
              name="trim"
              label={
                <Checkbox className="-mr-2" defaultChecked={true}>
                  {t('Trim')}
                </Checkbox>
              }
              className="mb-2"
              initialValue={'NO'}
            >
              <Select placeholder={t('Select')} size="small">
                {TRIM.map((it) => (
                  <Select.Option key={it.key} value={it.key} title={it.title}>
                    {t(it.title)}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col xs={24} md={12}>
            <Form.Item
              name="orientation"
              label={
                <Checkbox className="-mr-2" defaultChecked={true}>
                  {t('Orientation')}
                </Checkbox>
              }
              className="mb-2"
              initialValue={'PORTRAIT'}
            >
              <Select placeholder={t('Select')} size="small">
                {ORIENTATION.map((it) => (
                  <Select.Option key={it.key} value={it.key} title={it.title}>
                    {t(it.title)}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col xs={24} md={12}>
            <Form.Item
              name="film_size"
              label={
                <Checkbox className="-mr-2" defaultChecked={true}>
                  {t('Film Size')}
                </Checkbox>
              }
              className="mb-2"
              initialValue={'8INX10IN'}
            >
              <Select placeholder={t('Select')} size="small">
                {FILM_TYPE.map((it) => (
                  <Select.Option key={it.key} value={it.key} title={it.title}>
                    {t(it.title)}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col xs={24} md={12}>
            <Form.Item
              name="density_max"
              label={
                <Checkbox className="-mr-2" defaultChecked={true}>
                  {t('Max')}
                </Checkbox>
              }
              className="mb-2"
              initialValue={'65535'}
            >
              <Input size="small" placeholder={t('Enter Patient ID')} />
            </Form.Item>
          </Col>
          <Col xs={24} md={12}>
            <Form.Item
              name="density_min"
              label={
                <Checkbox className="-mr-2" defaultChecked={true}>
                  {t('Min')}
                </Checkbox>
              }
              className="mb-2"
              initialValue={'0'}
            >
              <Input size="small" placeholder={t('Enter Patient ID')} />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col xs={24} md={12}>
            <Form.Item
              name="density_border"
              label={
                <Checkbox className="-mr-2" defaultChecked={true}>
                  {t('Border')}
                </Checkbox>
              }
              className="mb-2"
              initialValue={'BLACK'}
            >
              <Select placeholder={t('Select')} size="small">
                {DENSITY_COLOR.map((it) => (
                  <Select.Option key={it.key} value={it.key} title={it.title}>
                    {t(it.title)}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col xs={24} md={12}>
            <Form.Item
              name="density_empty"
              label={
                <Checkbox className="-mr-2" defaultChecked={true}>
                  {t('Empty')}
                </Checkbox>
              }
              className="mb-2"
              initialValue={'BLACK'}
            >
              <Select placeholder={t('Select')} size="small">
                {DENSITY_COLOR.map((it) => (
                  <Select.Option key={it.key} value={it.key} title={it.title}>
                    {t(it.title)}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default PrintSettingsExtendForm;
